import React from 'react'
import moment from 'moment'
import clsx from 'clsx'
import { useHistory } from 'react-router'
import { Tooltip } from '@mui/material'
import { ClipboardTick } from 'iconsax-react'

import { Routes } from '../../../../../Routes'
import { getDateDistance } from '../../../../../utilities'
import useStyles from './styles'

const MAX_DISPLAY = 4

const ClientTasks = ({ client }) => {
  const history = useHistory()

  const classes = useStyles()

  const getClassName = React.useCallback(
    task => {
      const task_colors = {
        '-1': classes.taskDue,
        0: classes.taskSoon,
        1: classes.taskGood
      }

      const distance = getDateDistance(task.due_date)
      return task_colors[distance]
    },
    [classes.taskDue, classes.taskSoon, classes.taskGood]
  )

  const handleClick = React.useCallback(
    id => {
      history.push(`${Routes.TASKS}/${id}`)
    },
    [history]
  )

  if (!client.tasks || client.tasks.length === 0) {
    return null
  }

  const first = client.tasks.slice(0, MAX_DISPLAY)
  const rest = client.tasks.slice(MAX_DISPLAY)

  return (
    <div className={classes.root}>
      {first.map((task, i) => (
        <Tooltip
          key={i}
          title={
            <div className={classes.details}>
              <div>Name: {task.title}</div>
              <div>
                Due Date: {moment(task.due_date).format('MM/DD/YYYY hh:mm a')}
              </div>
            </div>
          }
          arrow
        >
          <div
            onClick={() => handleClick(task.id)}
            style={{ cursor: 'pointer' }}
          >
            <ClipboardTick className={clsx(classes.task, getClassName(task))} />
          </div>
        </Tooltip>
      ))}
      {rest.length > 0 && <div className='more'>+{rest.length}</div>}
    </div>
  )
}

export default ClientTasks
